import type { ChatProgress, ChatProgressHistoryEntry } from './signlaRTypes';

export type ChatbotVariant = 'maya' | 'sylvia' | 'padre';

export interface AIResponseMetadata {
  aiModelName?: string;
  aiReasoning?: string;
}

export interface HtmlSnapshotSegmentState {
  html: string;
  sequence: number;
  isFinal: boolean;
}

export interface HtmlSnapshotResponseState {
  responseId: string;
  sessionId: string;
  agentId: string | null;
  legacyTarget: string;
  lastSequence: number;
  segments: Record<number, HtmlSnapshotSegmentState>;
  legacyExtras: string[];
  isComplete: boolean;
  streamingStopped?: boolean;
  supportsRequestCancellation?: boolean;
  backendCancellationStatus?: 'pending' | 'accepted' | 'failed';
  progress?: ChatProgress;
  progressHistory?: ChatProgressHistoryEntry[];
  progressSuppressed?: boolean;
  progressStartedAt?: number;
  progressElapsedMs?: number;
  /** Action choices offered with this response; cleared once the member sends anything. */
  actionOffer?: { offerId: string; options: { id: string; label: string }[] };
}

export interface OrderedHtmlSnapshotSegment extends HtmlSnapshotSegmentState {
  segmentId: number;
}

export interface ConversationItemType extends AIResponseMetadata {
  text: string;
  isSent: boolean;
  createdAt?: string;
  responseId?: string;
}

export enum AIResponseStatusType {
  READY = 'ready',
  PENDING = 'pending',
  PRINTING = 'printing',
  ERROR = 'error',
}

export enum AIContextMode {
  ALL_ROOMS = 'auto',
  CURRENT_ROOM = 'currentRoom',
  CURRENT_ROOM_AND_SUB_ROOMS = 'currentRoomAndSubRooms',
  HEALTH_JOURNEY = 'healthJourney',
  WEB_SEARCH = 'webSearch',
}
